import React, { useEffect, useState } from "react";

import { API_DOWN, API_UP, apiIsDown } from "../../lib/apiStatus";
import s from "./apiStatus.module.scss";

// "Updating · reconnecting…" while the API restarts (see apiStatus.js)
const ApiStatus = () => {
  const [down, setDown] = useState(apiIsDown());
  const [back, setBack] = useState(false);

  useEffect(() => {
    let t;
    const onDown = () => {
      clearTimeout(t);
      setBack(false);
      setDown(true);
    };
    const onUp = () => {
      setDown(false);
      setBack(true);
      t = setTimeout(() => setBack(false), 2500);
    };
    window.addEventListener(API_DOWN, onDown);
    window.addEventListener(API_UP, onUp);
    return () => {
      clearTimeout(t);
      window.removeEventListener(API_DOWN, onDown);
      window.removeEventListener(API_UP, onUp);
    };
  }, []);

  if (!down && !back) return null;
  return (
    <div className={back ? `${s.bar} ${s.ok}` : s.bar} role="status">
      {back ? (
        "Back online"
      ) : (
        <>
          <i className={s.spin} />
          We're updating VBear · reconnecting in a moment…
        </>
      )}
    </div>
  );
};

export default ApiStatus;
